'use client'
import { debounce } from 'lodash'
import { useParams, useRouter } from 'next/navigation'
import type { ChangeEvent, FC } from 'react'
import { useCallback, useState } from 'react'
import { useLocalisation } from '@/tools/i18n/client'
import { useErrorHandling } from '@/tools/o11y/client'
import { MagnifyingGlassIcon, SearchInput, SearchSize } from '@/tools/ui'

export const UserSearchInput: FC = () => {
  const { t } = useLocalisation()
  const { withErrorTracking } = useErrorHandling()
  const router = useRouter()
  const [searchInput, setSearchInput] = useState('')
  const { language, country, city } = useParams()

  const redirectToSearchPage = (searchValue: string) => {
    const sanitisedSearchValue = encodeURIComponent(searchValue)
    const newPath = `/${country}/${language}/${city}/search-glovo/${sanitisedSearchValue}`
    router.push(newPath)
  }

  const debouncedSearch = debounce((searchValue: string) => {
    redirectToSearchPage(searchValue)
  }, 500)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleSearchInput = useCallback(
    withErrorTracking((e: ChangeEvent<HTMLInputElement>) => {
      setSearchInput(e.target.value)
      debouncedSearch(e.target.value)
    }),
    []
  )

  return (
    <SearchInput
      aria-label={t('store.navigation.search')}
      leadingIcon={MagnifyingGlassIcon}
      placeholder={t('common.search')}
      size={SearchSize.small}
      value={searchInput}
      onChange={handleSearchInput}
    />
  )
}
